import { Button, Modal, PendingGrid } from '@finbeat/react-toolkit';
import { AxiosError } from 'axios';
import { getCrossLinks } from 'axios/clientApi';
import useApi from 'hooks/useApi';
import { AxiosErrorResponse } from 'models/api/axiosErrorResponse';
import { ClientCrossLink } from 'models/api/client';
import Id from 'models/id';
import { Trans } from 'react-i18next';
import { ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useClientWorkplaceState } from './Clients';

type ClientCrossLinksModalProps = Id & {
    isOpen?: boolean;
    toggle: (item: string) => void;
};

const ClientCrossLinksModal = ({ id, isOpen = false, toggle }: ClientCrossLinksModalProps) => {
    const api = useApi();
    const { handleError } = useClientWorkplaceState();

    return (
        <Modal size="xl" isOpen={isOpen} toggle={() => toggle('')} scrollable>
            <ModalHeader toggle={() => toggle('')}>
                <Trans i18nKey="BackOfficeCrossLinks" /> #{id}
            </ModalHeader>
            <ModalBody className="custom-scrollbar">
                <PendingGrid<ClientCrossLink, AxiosError<AxiosErrorResponse>>
                    storagePath="client-cross-links-grid"
                    columns={[
                        { key: 'id', name: <Trans i18nKey="BackOfficeClientId" /> },
                        { key: 'brandName', name: <Trans i18nKey="BackOfficeBrand" /> },
                        { key: 'login', name: <Trans i18nKey="BackOfficeLogin" /> },
                        { key: 'fio', name: <Trans i18nKey="BackOfficeFio" /> },
                        {
                            key: 'intersectionType',
                            name: <Trans i18nKey="BackOfficeIntersectionType" />,
                        },
                        { key: 'val', name: <Trans i18nKey="BackOfficeValue" /> },
                    ]}
                    query={() => getCrossLinks(api, id || 0)}
                    handleError={(error: AxiosError<AxiosErrorResponse>) => {
                        handleError(error.response?.data);
                        toggle('');
                    }}
                    queryKey={'clientCrossLinks' + id}
                    queryEnable={isOpen}
                />
            </ModalBody>
            <ModalFooter>
                <Button color="secondary" onClick={() => toggle('')}>
                    <Trans i18nKey="BackOfficeCancel" />
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ClientCrossLinksModal;
